import { render, staticRenderFns } from "./KomlabsRegistrationFields.vue?vue&type=template&id=c2f34182&"
import script from "./KomlabsRegistrationFields.vue?vue&type=script&lang=js&"
export * from "./KomlabsRegistrationFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports